<script>
import  {places} from "@/consts/prize"
export default {
  name: "PrizePlaceCard.vue",
  props:["place", "prizeAmount", "item"],
  data() {
    return {
      places: {...places},
    }
  }
}
</script>

<template>
  <div class="prize-card-wrapper position-relative w-100">
    <div class="vertical-line position-absolute" :style="{
      background: places[place].colors.color
    }">
    </div>
    <div class="d-flex justify-content-between align-items-end px-2 h-100 text-white p-2" :style="{
      background: places[place].colors.gradient,
    }">
      <div>
        <h5 class="place-player-name text-uppercase m-0 px-1">{{item.name}}</h5>
      </div>
      <div class="">
        <h6 class="place-label text-uppercase text-right m-0">{{places[place].label}}</h6>
        <h6 class="place-prize text-uppercase m-0"><span class="text-won small" style="color: rgba(187,187,187,0.65)">WON</span> {{item.prize}}</h6>
      </div>
    </div>
  </div>
</template>

<style scoped>
.prize-card-wrapper {
  height: 56px;
  background: rgba(18, 18, 18, 0.9);
}
.vertical-line {
  top:0;
  left:0;
  width: 4px;
  height: 100%;
  opacity: 0.4;
}
.place-player-name{
  font-family: "sqwaredsemi_bold" !important;
  font-size: 12pt !important;
}
.place-prize{
  font-family: "sqwaredsemi_bold" !important;
}
.place-label{
  font-family: "sqwaredregular" !important;
  font-size: 10pt !important;
}
</style>